import React from 'react';
import Posts from '../Components/Posts';

const Home = () => {
  return (
    <Posts/>
  )
}

export default Home